import { render, staticRenderFns } from "./FormPriorityListField.vue?vue&type=template&id=2d145be8&scoped=true"
import script from "./FormPriorityListField.vue?vue&type=script&lang=ts"
export * from "./FormPriorityListField.vue?vue&type=script&lang=ts"
import style0 from "./FormPriorityListField.vue?vue&type=style&index=0&id=2d145be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d145be8",
  null
  
)

export default component.exports